<template>
  <div class="home-container">
    <!-- 移除 Header 组件 -->
    
    <h1 class="page-title">课程学习</h1>
    
    <div class="course-container" v-show="currentPage === 1">
      <div class="course-grid">
        <!-- Page 1 Content -->
        <div class="course-item" @click="goToSubPage('dhsm')">
          <img src="@/assets/img/dhsm.jpg" alt="动画素描">
          <div class="course-content">
            <h3>动画素描</h3>
            <p>掌握动画角色设计的基础素描技巧，学习线条表达和形体塑造。</p>
            <router-link to="/sub-page/dhsm" class="course-btn">进入学习</router-link>
          </div>
        </div>
        
        <div class="course-item" @click="goToSubPage('dhsc')">
          <img src="@/assets/img/dhsc.jpg" alt="动画色彩">
          <div class="course-content">
            <h3>动画色彩</h3>
            <p>学习动画作品中的色彩搭配与应用，掌握情绪与氛围的色彩表达。</p>
            <router-link to="/sub-page/dhsc" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <!-- 修复课程项目的路由链接 -->
        <div class="course-item" @click="goToSubPage('dhzxsjjc')">
          <img src="@/assets/img/dhzxsjjc.jpg" alt="动画造型设计基础">
          <div class="course-content">
            <h3>动画造型设计基础</h3>
            <p>学习动画作品中的角色、场景等元素的创意与设计。</p>
            <router-link to="/sub-page/dhzxsjjc" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('dhjb')">
          <img src="@/assets/img/dhjb.jpg" alt="动画剧本">
          <div class="course-content">
            <h3>动画剧本</h3>
            <p>学习情节结构、角色发展和对话创作，编写与发展引人入胜的动画故事。</p>
            <router-link to="/sub-page/dhjb" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('dhgl')">
          <img src="@/assets/img/dhgl.jpg" alt="动画概论">
          <div class="course-content">
            <h3>动画概论</h3>
            <p>学习动画历史、技术与创作流程。</p>
            <router-link to="/sub-page/dhgl" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('ktds')">
          <img src="@/assets/img/ktds.jpg" alt="动画概论">
          <div class="course-content">
            <h3>卡通雕塑</h3>
            <p>课程融合三维造型与动画原理，涵盖雕塑技巧、动态构造，旨在让学生将运动与艺术融合，为未来的创意动画和艺术项目提供扎实基础。</p>
            <router-link to="/sub-page/ktds" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('dhbj')">
          <img src="@/assets/img/dhbj.jpg" alt="动画背景绘制">
          <div class="course-content">
            <h3>动画背景绘制</h3>
            <p>学习动画场景设计与绘制能力，强调透视、色彩与氛围营造。</p>
            <router-link to="/sub-page/dhbj" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('ydhjc')">
          <img src="@/assets/img/ydhjc.jpg" alt="原动画基础">
          <div class="course-content">
            <h3>原动画基础</h3>
            <p>教授原动画设计的关键技法，涵盖角色设计、场景构建及动态表现等。</p>
            <router-link to="/sub-page/ydhjc" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('txtx')">
          <img src="@/assets/img/photoshop.jpg" alt="图形图像处理">
          <div class="course-content">
            <h3>图形图像处理</h3>
            <p>教授学生深入理解和熟练运用图形图象处理软件的技能。通过课程，学生将学会图像编辑、合成和修饰，掌握图层管理、色彩校正和滤镜应用等关键技术。</p>
            <router-link to="/sub-page/ydhjc" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('illustrator')">
          <img src="@/assets/img/Illustrator.jpg" alt="矢量图形设计">
          <div class="course-content">
            <h3>矢量图形设计</h3>
            <p>学会矢量图形设计中路径绘制、形状构建和颜色管理等关键技术，为插画和界面设计等领域提供实际操作能力。</p>
            <router-link to="/sub-page/ydhjc" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('swjmjc')">
          <img src="@/assets/img/swjmjc.jpg" alt="三维建模基础">
          <div class="course-content">
            <h3>三维建模基础</h3>
            <p>学会基本的三维几何形状创建、表面调整和材质应用，建立坚实的三维建模基础</p>
            <router-link to="/sub-page/swjmjc" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('animate')">
          <img src="@/assets/img/animate.jpg" alt="二维动画制作">
          <div class="course-content">
            <h3>animate动画制作</h3>
            <p>学习二维动画中角色设计、动画制作和互动元素制作。</p>
            <router-link to="/sub-page/animate" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('swjsdhsj')">
          <img src="@/assets/img/swjsdhsj.jpg" alt="三维角色动画设计">
          <div class="course-content">
            <h3>三维角色动画设计</h3>
            <p>学习三维角色动画设计的核心原则和技能，涵盖姿势、表情和运动等。</p>
            <router-link to="/sub-page/swjsdhsj" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('yxsj')">
          <img src="@/assets/img/yxsj.jpg" alt="音效设计制作">
          <div class="course-content">
            <h3>音效设计制作</h3>
            <p>学习声音设计、录音和编辑技术。</p>
            <router-link to="/sub-page/swjsdhsj" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('swhqtx')">
          <img src="@/assets/img/swhqtx.jpg" alt="三维后期特效">
          <div class="course-content">
            <h3>三维后期特效</h3>
            <p>教授三维后期特效的创作方法与技能，涵盖粒子系统、光影效果及视觉增强等。</p>
            <router-link to="/sub-page/swhqtx" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('yxyqjc')">
          <img src="@/assets/img/yxyqjc.jpg" alt="游戏引擎基础">
          <div class="course-content">
            <h3>游戏引擎基础</h3>
            <p>学生将学会创建场景、导入资源、应用物理引擎等技能。</p>
            <router-link to="/sub-page/yxyqjc" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('dhdyjc')">
          <img src="@/assets/img/dhdyjc.jpg" alt="动画导演基础">
          <div class="course-content">
            <h3>动画导演基础</h3>
            <p>学生将学会创建场景、导入资源、应用物理引擎等技能。</p>
            <router-link to="/sub-page/dhdyjc" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('dhstyy')">
          <img src="@/assets/img/dhstyy.jpg" alt="动画视听语言">
          <div class="course-content">
            <h3>动画视听语言</h3>
            <p>将掌握音效设计、配乐、剧情融合等技能。</p>
            <router-link to="/sub-page/dhstyy" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('ystxzz')">
          <img src="@/assets/img/ystxzz.jpg" alt="影视特效制作">
          <div class="course-content">
            <h3>影视特效制作</h3>
            <p>教授影视特效制作的关键技术，包括视觉效果、合成和数字增强。</p>
            <router-link to="/sub-page/ystxzz" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('fxxbj')">
          <img src="@/assets/img/fxxbj.jpg" alt="非线性编辑">
          <div class="course-content">
            <h3>非线性编辑</h3>
            <p>掌握关键教效果、合成和数字增强授影视特效。</p>
            <router-link to="/sub-page/fxxbj" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <div class="course-item" @click="goToSubPage('swdh')">
          <img src="@/assets/img/swdh.jpg" alt="非线性编辑">
          <div class="course-content">
            <h3>三维动画</h3>
            <p>掌握三维动画与游戏场景设计的基本概念、基本要求和基本的设计原则。</p>
            <router-link to="/sub-page/swdh" class="course-btn">进入学习</router-link>
          </div>
        </div>
        <!-- 其他课程项... -->
      </div>
    </div>

    <div class="course-container" v-show="currentPage === 2">
      <div class="course-grid">
        <!-- Page 2 Content -->
        <div class="course-item" @click="goToSubPage('dhjtsjjf')">
          <img src="@/assets/img/dhjtsjjf.jpg" alt="动画镜头设计技法">
          <div class="course-content">
            <h3>动画镜头设计技法</h3>
            <p>学习动画镜头语言与视觉叙事技巧，掌握镜头运动与场景转换。</p>
            <router-link to="/sub-page/dhjtsjjf" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('lw')">
          <img src="@/assets/img/lw.jpg" alt="论文写作与研究方法">
          <div class="course-content">
            <h3>论文写作与研究方法</h3>
            <p>学习文献查找、分析、结构化写作等。</p>
            <router-link to="/sub-page/lw" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('dgdh')">
          <img src="@/assets/img/dgdh.jpg" alt="定格动画">
          <div class="course-content">
            <h3>定格动画</h3>
            <p>学习文献查找、分析、结构化写作等。</p>
            <router-link to="/sub-page/dgdh" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('spine')">
          <img src="@/assets/img/Spine2D.jpg" alt="二维骨骼动画制作">
          <div class="course-content">
            <h3>二维骨骼动画制作</h3>
            <p>学习二维骨骼动画制作的核心技能，涵盖骨骼动画、插槽绑定及交互特效。</p>
            <router-link to="/sub-page/dgdh" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('wzdh')">
          <img src="@/assets/img/TBH.jpeg" alt="二维无纸动画制作">
          <div class="course-content">
            <h3>二维无纸动画制作</h3>
            <p>学习TBH核心技能，涵盖骨骼动画、插槽绑定及交互特效。</p>
            <router-link to="/sub-page/wzdh" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('ca')">
          <img src="@/assets/img/CharacterAnimato.jpg" alt="二维动作捕捉">
          <div class="course-content">
            <h3>二维动作捕捉</h3>
            <p>学习二维动作捕捉技术，涵盖角色建立、实时动画及交互设计。</p>
            <router-link to="/sub-page/ca" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('mg')">
          <img src="@/assets/img/MG.jpg" alt="MG动画制作">
          <div class="course-content">
            <h3>MG动画制作</h3>
            <p>学习Motion Graphics动画的创作技术，包括图形设计、动画转场和效果制作。</p>
            <router-link to="/sub-page/mg" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('szgg')">
          <img src="@/assets/img/szgg.jpg" alt="数字广告设计">
          <div class="course-content">
            <h3>数字广告设计</h3>
            <p>学习数字广告设计的核心技巧，包括平面、视频和互动广告创作。</p>
            <router-link to="/sub-page/szgg" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('substance-painter')">
          <img src="@/assets/img/SubstancePainter.jpg" alt="贴图制作">
          <div class="course-content">
            <h3>贴图制作</h3>
            <p>学习贴图制作技术，涵盖材质绘制、贴图渲染和纹理处理。</p>
            <router-link to="/sub-page/substance-painter" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('dlxmn')">
          <img src="@/assets/img/dlxmn.jpg" alt="动力学模拟">
          <div class="course-content">
            <h3>动力学模拟</h3>
            <p>学习动力学模拟的原理与实践，包括物体运动、碰撞和弹性等。</p>
            <router-link to="/sub-page/dlxmn" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('jsfzsj')">
          <img src="@/assets/img/jsfzsj.jpg" alt="角色服装制作">
          <div class="course-content">
            <h3>角色服装制作</h3>
            <p>学习角色服装制作技术，涵盖服装建模、材质贴图和逼真仿真。</p>
            <router-link to="/sub-page/jsfzsj" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('bqdhzz')">
          <img src="@/assets/img/bqdhzz.jpg" alt="表情动画制作">
          <div class="course-content">
            <h3>表情动画制作</h3>
            <p>学习表情动画制作技术，涵盖面部表情、情感传达及唇形同步。</p>
            <router-link to="/sub-page/bqdhzz" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('szdk')">
          <img src="@/assets/img/szdk.jpg" alt="数字雕塑">
          <div class="course-content">
            <h3>数字雕塑</h3>
            <p>学习数字雕塑技术，涵盖模型创作、细节雕刻和纹理绘制。</p>
            <router-link to="/sub-page/szdk" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('xrjs')">
          <img src="@/assets/img/xrjs.jpeg" alt="渲染技术">
          <div class="course-content">
            <h3>渲染技术</h3>
            <p>学习渲染技术，涵盖光照、阴影、材质、全局光照和体积渲染等。</p>
            <router-link to="/sub-page/xrjs" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('yxyh')">
          <img src="@/assets/img/yxyh.jpeg" alt="游戏原画设计">
          <div class="course-content">
            <h3>游戏原画设计</h3>
            <p>学习游戏原画设计，涵盖角色、场景和道具设计。</p>
            <router-link to="/sub-page/yxyh" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('yxmxbd')">
          <img src="@/assets/img/yxmxbd.jpeg" alt="游戏模型绑定">
          <div class="course-content">
            <h3>游戏模型绑定</h3>
            <p>学习游戏模型绑定，掌握骨骼系统和动画控制技术。</p>
            <router-link to="/sub-page/yxmxbd" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('yxtxzz')">
          <img src="@/assets/img/yxtxzz.png" alt="游戏特效制作">
          <div class="course-content">
            <h3>游戏特效制作</h3>
            <p>学习游戏特效制作，掌握粒子系统和视觉效果技术。</p>
            <router-link to="/sub-page/yxtxzz" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('yxjmsj')">
          <img src="@/assets/img/yxjmsj.jpg" alt="游戏界面设计与制作">
          <div class="course-content">
            <h3>游戏界面设计与制作</h3>
            <p>学习游戏界面设计，掌握UI元素设计和交互系统开发。</p>
            <router-link to="/sub-page/yxjmsj" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('yxdbzz')">
          <img src="@/assets/img/yxdbzz.jpeg" alt="游戏地编制作">
          <div class="course-content">
            <h3>游戏地编制作</h3>
            <p>学习游戏地形设计，掌握关卡构建和环境美化技术。</p>
            <router-link to="/sub-page/yxdbzz" class="course-btn">进入学习</router-link>
          </div>
        </div>

        <div class="course-item" @click="goToSubPage('yxkf')">
          <img src="@/assets/img/yxkf.jpeg" alt="游戏开发">
          <div class="course-content">
            <h3>游戏开发</h3>
            <p>学习游戏设计与编程，掌握游戏开发的核心技能。</p>
            <router-link to="/sub-page/yxkf" class="course-btn">进入学习</router-link>
          </div>
        </div>










        <!-- 其他课程项... -->
      </div>
    </div>

    <div class="page-switcher">
      <button @click="switchPage(1)" :class="{ active: currentPage === 1 }">1</button>
      <button @click="switchPage(2)" :class="{ active: currentPage === 2 }">2</button>
    </div>
    
    <!-- 移除 Footer 组件 -->
  </div>
</template>

<script>
// 移除组件导入
export default {
  name: 'HomeView',
  // 移除组件注册
  data() {
    return {
      currentPage: 1
    }
  },
  methods: {
    switchPage(pageNumber) {
      this.currentPage = pageNumber
    },
    goToSubPage(page) {
      this.$router.push(`/sub-page/${page}`)
    }
  }
}
</script>

<style scoped>
.home-container {
  margin: 0;
  padding: 0;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.page-title {
  text-align: center;
  margin-top: 15px;
  margin-bottom: 15px;
  color: var(--text-color, #333);
  font-size: 26px;
  font-weight: 600;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  position: relative;
}

.page-title::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, var(--primary-color, #4285f4), var(--secondary-color, #34a853));
  border-radius: 3px;
}

.course-container {
  padding: 15px;
  max-width: 1200px;
  margin: 0 auto;
}

.course-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 22px;
}

.course-item {
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.course-item:hover {
  transform: translateY(-6px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.course-item img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.course-item:hover img {
  transform: scale(1.05);
}

.course-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.course-item h3 {
  margin-top: 0;
  margin-bottom: 8px;
  color: #2c3e50;
  font-size: 17px;
  font-weight: 600;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.course-item p {
  color: #5f6368;
  margin-bottom: 16px;
  font-size: 14px;
  line-height: 1.5;
  flex-grow: 1;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.course-btn {
  display: inline-block;
  background-color: #4285f4;
  color: white;
  padding: 8px 14px;
  border-radius: 4px;
  text-decoration: none;
  font-weight: 500;
  text-align: center;
  transition: all 0.3s ease;
  font-size: 14px;
  align-self: flex-start;
  box-shadow: 0 2px 5px rgba(66, 133, 244, 0.3);
}

.course-btn:hover {
  background-color: #3367d6;
  box-shadow: 0 4px 8px rgba(66, 133, 244, 0.4);
}

.page-switcher {
  display: flex;
  justify-content: center;
  margin: 25px 0 35px;
  gap: 8px;
}

.page-switcher button {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background-color: #f1f3f4;
  color: #5f6368;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.page-switcher button:hover {
  background-color: #e8f0fe;
  color: #4285f4;
}

.page-switcher button.active {
  background-color: #4285f4;
  color: white;
  box-shadow: 0 2px 5px rgba(66, 133, 244, 0.3);
}

@media screen and (max-width: 768px) {
  .page-title {
    font-size: 22px;
    margin-top: 20px;
    margin-bottom: 15px;
  }
  
  .course-grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 18px;
  }
  
  .course-content {
    padding: 12px;
  }
  
  .course-item img {
    height: 130px;
  }
  
  .course-item h3 {
    font-size: 16px;
  }
  
  .course-item p {
    font-size: 13px;
    margin-bottom: 12px;
  }
  
  .course-btn {
    padding: 6px 12px;
    font-size: 13px;
  }
}

@media screen and (max-width: 480px) {
  .course-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .course-item img {
    height: 160px;
  }
  
  .page-title {
    font-size: 20px;
    margin-top: 15px;
    margin-bottom: 15px;
  }
  
  .page-title::after {
    width: 50px;
    height: 2px;
  }
}
</style>